import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupById,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../../i18n/de.json';
import { SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG } from './auftrag.permissions';
import { SOFTLINE_CONFIG_WERKSTAETTENAUFTRAG } from './auftrag.shared';

export const auftragProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'werkstaettenauftrag',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#WERKSTAETTENAUFTRAG.APP',
      icon: 'fa-regular fa-garage',
      route: '/werkstaettenauftrag',
      color: 'bg-accent text-white',
      permission: SOFTLINE_PERMISSION_WERKSTAETTENAUFTRAG,
      group: getModuleGroupById(11),
    });
  }),
  {
    provide: SOFTLINE_CONFIG_WERKSTAETTENAUFTRAG,
    useValue: {
      aufgabeName: 'Warenkorb Werkstatt',
    },
  },
];
